



















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import GlobalBus from '@/plugins/GlobalBus';
import { GlobalBusNames, SearchItem } from '@/templates/DataNames';
import { convertToHtmlHelper, currentInstance, parseLanguageHelper } from '@/heplers';
import DocIcon from '@/components/ui/icons/DocIcon.vue';
import { RootNamesInterface, treatmentSearchData } from '@/heplers/searchHelpers';
import { parseAdvancedHrefHelper } from '@/heplers/stringHelpers';
import { State } from 'vuex-class';

@Component({
  components: { DocIcon },
  filters: {
    parseLanguage: parseLanguageHelper,
  },
})
export default class SearchResult extends Vue {
  @State rootNames: RootNamesInterface;
  public parseData: { [key in RootNamesInterface[keyof RootNamesInterface]]: SearchItem[] } = {};
  public inputString = '';
  public totalResults = '0';
  public isKit: boolean = currentInstance === 'kit';

  get computeSearchClasses() {
    return {
      'is-void': !this.inputString.length,
      'is-empty': this.inputString.length && !Object.keys(this.parseData).length,
    };
  }

  get computeSearchLink() {
    let searchSort = Object.keys(this.rootNames).filter((fqdn) =>
      this.$route.meta.fqdn.includes(fqdn)
    )[0];

    if (this.isKit) searchSort = '';
    else searchSort = searchSort?.length ? `&sort=${searchSort}` : '';

    let result = currentInstance === 'kit' ? '/kit/docs/search?q=' : '/docs/search?q=';

    return result + this.inputString + searchSort;
  }

  beforeDestroy() {
    GlobalBus.off(GlobalBusNames.SEARCHRESULT);
  }

  mounted() {
    GlobalBus.on(GlobalBusNames.SEARCHRESULT, (data: any) => {
      this.inputString = data.inputString || '';
      if (!data.searchResults.results) return;

      this.parseData = treatmentSearchData(
        data.searchResults.results,
        this.inputString,
        this.rootNames
      );

      this.totalResults = data.searchResults.pagination.totalCount;
    });
  }

  closeSearch() {
    this.$emit('close_search');
  }

  parseHref(fqdn: string, kind: string) {
    return parseAdvancedHrefHelper(fqdn, kind, '/docs/');
  }

  convertToHtml(mdString: string) {
    mdString = parseLanguageHelper(mdString);

    return convertToHtmlHelper(mdString);
  }
}
